import { SvgIcon, SvgIconProps } from "@mui/material";

const Target = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="11.6969"
          cy="12.3032"
          rx="9.69691"
          ry="9.69673"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <ellipse
          cx="11.6968"
          cy="12.3029"
          rx="6.06057"
          ry="6.06046"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <ellipse
          cx="11.6967"
          cy="12.3026"
          rx="2.42423"
          ry="2.42418"
          fill="currentColor"
        />
        <path
          d="M17.1514 4.42418V6.84837H19.5756L21.9998 4.42418H19.5756V2L17.1514 4.42418Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M17.1513 6.8479L11.6968 12.3023"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Target;
